/*
 * @Description:抖音待编渠道路由
 * @Author: lzy
 * @LastEditors  : cc
 * @Date: 19-11-03
 * @LastEditTime : 2020-02-07 18:58:13
 */
'use strict';
angular.module('editQiehaoToBeCompiledRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.editctr.qiehao.waitcompiled', {
                url: '/waitcompiled?account&isOriginal&channelid', // accountid->账号 channelid-> 渠道id
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/qiehao/toBeCompiled/main.html',
                        controller: 'EditQiehaoToBeCompiledCtrl',
                    },
                },
            })
            .state('qiehaovideo', {
                url: '/qiehaovideo?qiehaoaccount&qiehaoarticleid&isOriginal&qiehaoplatform&iwometadataid&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/qiehao/toBeCompiled/video/qiehao_video.html',
                        controller: 'editingCenterQiehaoVideoCtrl',
                    },
                },
            })
            .state('qiehaonews', {
                url: '/qiehaonews?qiehaoaccount&qiehaoarticleid&isOriginal&qiehaoplatform&iwometadataid&isawaitrevise', // isawaitrevise->待修订
                views: {
                    '': {
                        templateUrl: './editingCenter/qiehao/toBeCompiled/news/qiehao_news.html',
                        controller: 'editingCenterQiehaoNewsCtrl',
                    },
                },
            })
            .state('qiehaoatlas', {
                url: '/qiehaoatlas?qiehaoaccount&qiehaoarticleid&isOriginal&qiehaoplatform&iwometadataid&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/qiehao/toBeCompiled/atlas/qiehao_atlas.html',
                        controller: 'editingCenterQiehaoAtlasCtrl',
                    },
                },
            });
    },
]);
